<template>
  <b-container id="union">
    <b-row>
      <topbar />
    </b-row>
    <b-row>
      <search />
    </b-row>
    <div>
      <cart-side />
    </div>
    <b-row>
      <app-nav />
    </b-row>
    <b-row class="union-header">
      <b-col cols="12" class="union-list">
        <b-col v-for="(item,index) in LMSTItemList" :key="index" cols="3">
          <manufacturer-item :item="item" class="box" @successtocart="successToCart" />
        </b-col>
      </b-col>
    </b-row>
    <b-toast id="msg" class="msg" no-close-button variant="danger" static auto-hide-delay="100">
      {{ Msg }}
    </b-toast>
    <b-row class="banner" />
    <b-row><div class="title">优势品种</div></b-row>
    <b-row class="item-list">
      <b-col v-for="(item,index) in YSPZItemList" :key="index" cols="3">
        <manufacturer-item :item="item" @successtocart="successToCart" />
      </b-col>
    </b-row>
    <div class="select-page">
      <span class="page-now" @click="firstPage">首页</span>
      <span class="page-now" @click="previousPage">上一页</span>
      <span class="page-now" @click="nextPage">下一页</span>
      <span class="page-now" @click="lastPage">尾页</span>
      <input v-model="pageInfo.index" class="page-now" @blur="getYSPZItems">/
      <span class="page-count">{{ pageInfo.pages }}</span>页
    </div>
    <div>
      <app-footer />
    </div>
  </b-container>
</template>

<script>
import footer from '@/components/Footer.vue'
import topbar from '@/components/TopBar.vue'
import CartSide from '../item/CartSide'
import search from '@/components/Search.vue'
import nav from '@/components/Nav.vue'
import manufacturerItem from '../manufacturer/ManufacturerItem.vue'

import { ItemService } from '@/service/ItemService'
export default {
  components: {
    search, topbar,
    'cart-side': CartSide,
    'manufacturer-item': manufacturerItem,
    'app-nav': nav,
    'app-footer': footer
  },
  data () {
    return {
      ItemsIds: [],
      Msg: '',
      LMSTItemList: [], // 联盟首推商品列表
      YSPZItemList: [], // 优势品种商品列表
      pageInfo: { count: '', index: 1, pages: '', size: 20 },
      chooseInfo: '',
      manufacturers: []
    }
  },
  mounted () {
    this.getYSPZItems()
    this.getLMSTItems()
  },
  methods: {
    successToCart () {
      this.showMsg('添加成功')
    },
    showMsg (msg) {
      this.Msg = msg
      this.$bvToast.show('msg')
    },
    test () {

    },
    getLMSTItems () {
      // 请求商品展示列表
      this.items = []
      this.ItemsIds = []
      var data = {
        type: -1,
        floorType: 2,
        unionId: this.$store.getters.unionId
      }
      this.ItemsIds = []
      var itemService = new ItemService(this.$axios)
      itemService.loadIndexItem(data).then(res => {
        console.log('sdaa++++++', res)
        res.forEach(item => {
          item.standard = item.norm
          item.showPrice = '加载中'
          item.num = 1
          if (item.shopName !== null && item.shopName.length > 12) {
            item.shopName = item.shopName.slice(0, 12) + '...'
          }
          if (item.standard !== null && item.standard.length > 15) {
            item.standard = item.standard.slice(0, 15) + '...'
          }
          if (item.manufacturer !== null && item.manufacturer.length > 19) {
            item.manufacturer = item.manufacturer.slice(0, 19) + '...'
          }
          this.ItemsIds.push(item.id)
          this.LMSTItemList.push(item)
        })
        this.resetItem(this.LMSTItemList)
      })
    },
    getYSPZItems () {
      // 请求商品详情
      this.YSPZItemList = []
      this.backTop()
      const data = {
        type: -1,
        floorType: 1,
        isShow: -1,
        index: this.pageInfo.index,
        size: this.pageInfo.size
      }
      var itemService = new ItemService(this.$axios)
      this.ItemsIds = []
      itemService.loadUnionItem(data).then(res => {
        console.log('sdaa++++++', res);
        ({ count: this.pageInfo.count, index: this.pageInfo.index, pages: this.pageInfo.pages, size: this.pageInfo.size } = res.pageInfo)
        res.items.forEach(item => {
          item.showPrice = '加载中'
          if (item.shopName !== null && item.shopName.length > 12) {
            item.shopName = item.shopName.slice(0, 12) + '...'
          }
          if (item.manufacturer !== null && item.manufacturer.length > 19) {
            item.manufacturer = item.manufacturer.slice(0, 19) + '...'
          }
          if (item.standard !== null && item.standard.length > 16) {
            item.standard = item.standard.slice(0, 16) + '...'
          }
          item.num = 1
          this.ItemsIds.push(item.id)
          this.YSPZItemList.push(item)
        })
        this.resetItem(this.YSPZItemList)
      })
    },
    resetItem (list) {
      // 重新给商品信息赋值
      var itemService = new ItemService(this.$axios)
      itemService.loadFullInfo(this.ItemsIds).then(res => {
        const itemMap = new Map()
        res.forEach(item => {
          itemMap.set(item.id, item)
        })
        list.forEach(item => {
          if (item.id === itemMap.get(item.id).id) {
            item.showPrice = '￥' + itemMap.get(item.id).showPrice.toFixed(2)
            if (item.shopName !== null && item.shopName.length > 12) {
              item.shopName = itemMap.get(item.id).shopName.slice(0, 12) + '...'
            }
            if (item.manufacturer !== null && item.shopName.length > 19) {
              item.manufacturer = itemMap.get(item.id).manufacturer.slice(0, 19) + '...'
            }
          }
        })
      })
    },
    firstPage () {
      if (this.pageInfo.index !== 1) {
        this.pageInfo.index = 1
        this.getYSPZItems()
      }
    },
    previousPage () {
      if (this.pageInfo.index !== 1) {
        this.pageInfo.index -= 1
        this.getYSPZItems()
      }
    },
    nextPage () {
      if (this.pageInfo.index !== this.pageInfo.pages) {
        this.pageInfo.index += 1
        this.getYSPZItems()
      }
    },
    lastPage () {
      if (this.pageInfo.index !== this.pageInfo.pages) {
        this.pageInfo.index = this.pageInfo.pages
        this.getYSPZItems()
      }
    },
    backTop () {
      document.scrollTop = 0
      document.documentElement.scrollTop = 0
      console.log('回到顶部')
    }
  }
}
</script>

<style scoped>
#union{
  text-align: center;
  min-height: 1950px;
}

.item-list{
  width: 1200px;
margin: 0 auto;
}
.banner{
  width: 1200px;
  height: 110px;
  margin: 0 auto;
  background-image: url('../../../static/images/unionBanner1.png')
}
.box{
  text-align: center;
  border: 1px solid #ebeaea;
}
.title{
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  margin: 20px auto
}
.union-header{
  background-image: url('../../../static/images/unionBanner.png');
  margin: 10px auto;
  width: 1200px;
  height: 415px;

}
.msg{
position:fixed;
top:40%;
left: 48%;
}
.union-list{
  padding-left: 10px;
  margin-top: 44px;
  background-color: #ffffff;
  display: flex;
  flex-wrap:wrap;
  height: 360px;
  overflow-y: scroll;

}
.page-now{
  margin-left: 20px;
  cursor:pointer;
  font-size: 14px;
  line-height: 30px;
    text-align: center;
    display: inline-block;
    height: 30px;
    width: 50px;
    background-color: #ffffff;
  }
.select-page{
  margin-top: 20px;
  z-index: 999
}
.page-count {
    color: #f00;
  }
</style>
